import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(theme => ({
    container: {
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'wrap',
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    dense: {
      marginTop: theme.spacing(2),
    },
    menu: {
      width: 200,
    },
    button: {
      margin: theme.spacing(1),
    },
    input: {
      display: 'none',
    },
  }));

  

export default function Signup(props) {

    const toHome = () => {
      props.history.push("/home")
    }

    const classes = useStyles();
    return (
        <div className={classes.container}>
            <h1> Sign Up! </h1>
            
            <TextField
                required
                id="outlined-required"
                label="Username"
                className={classes.textField}
                margin="normal"
                variant="outlined"
            />
            <TextField
                required
                id="outlined-required"
                label="Display Name"
                className={classes.textField}
                margin="normal"
                variant="outlined"
            />
            <TextField
                required
                id="outlined-required"
                type="password"
                label="Password"
                className={classes.textField}
                margin="normal"
                variant="outlined"
            />
            <Button variant="contained" color="primary" className={classes.button} onClick={toHome}>
                Sign Up 
            </Button>
        </div>
    )
}
